import { render, staticRenderFns } from "./StorageSpacesMediaComponent.vue?vue&type=template&id=5c6559bb&"
import script from "./StorageSpacesMediaComponent.vue?vue&type=script&lang=js&"
export * from "./StorageSpacesMediaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports